import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoginForm from './components/LoginForm';

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/vacancy', { replace: true });
  }, [user, navigate]);

  const handleLogin = async (loginVal: string, password: string) => {
    const ok = await login(loginVal, password);
    if (ok) navigate('/vacancy', { replace: true });
    return ok;
  };

  return (
    <div className="min-h-screen flex bg-[#0d0f18]" style={{ fontFamily: "'Outfit', sans-serif" }}>
      {/* Left branding panel */}
      <div className="hidden lg:flex lg:w-[45%] relative flex-col items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(135deg, #0a1628 0%, #0d2318 50%, #0a1628 100%)',
          }}
        />
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20geometric%20corporate%20network%20pattern%2C%20hexagonal%20mesh%2C%20dark%20teal%20emerald%20tones%2C%20futuristic%20technology%20background%2C%20subtle%20glow%20lines%2C%20deep%20dark%20background%2C%20minimal%20high-tech%20design%2C%20interconnected%20nodes%20pattern&width=700&height=900&seq=login_bg_001&orientation=portrait"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0f18]/60 via-transparent to-[#0d0f18]/80" />

        <div className="relative z-10 flex flex-col items-center text-center px-12">
          <div className="mb-10">
            <img
              src="https://storage.readdy-site.link/project_files/2bf8aaf3-0f30-40d5-be17-1c495b690c02/c01c7bf6-da01-4692-a287-7cfb8ff624a9_lTZGkXUbeeGGTSg_1769785028.png?v=61d175ca0083da25e9bd41f5ab3012cf"
              alt="Логотип"
              className="h-40 object-contain"
            />
          </div>
          <h2 className="text-3xl font-bold text-white mb-3 leading-tight">
            Корпоративный портал
          </h2>
          <p className="text-slate-400 text-sm tracking-wide mb-1">компании</p>
          <p
            className="text-lg font-bold tracking-[0.18em] uppercase mb-4"
            style={{
              color: '#4ade80',
              textShadow: '0 0 18px rgba(74,222,128,0.35)',
              fontFamily: "'Outfit', sans-serif",
              letterSpacing: '0.18em',
            }}
          >
            «ПЛАТФОРМА РЕШЕНИЙ»
          </p>
          <p className="text-slate-400 text-base leading-relaxed max-w-xs">
            Единое пространство для управления вашим рабочим процессом,
            расписанием и выплатами
          </p>

          <div className="mt-14 grid grid-cols-3 gap-6 w-full">
            {[
              { icon: 'ri-calendar-check-line', label: 'Расписание' },
              { icon: 'ri-wallet-3-line', label: 'Выплаты' },
              { icon: 'ri-folder-line', label: 'Проекты' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-emerald-500/10 border border-emerald-500/20">
                  <i className={`${item.icon} text-emerald-400 text-xl`} />
                </div>
                <span className="text-xs text-slate-400">{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute bottom-6 text-xs text-slate-600 z-10">
          v1.0.0 &nbsp;·&nbsp; 2026
        </div>
      </div>

      {/* Right login panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 lg:px-16">
        {/* Mobile logo */}
        <div className="lg:hidden mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/4e06b409-d517-4902-913c-3ae69444b76b.png"
            alt="Логотип"
            className="h-12 object-contain"
          />
        </div>

        <div className="w-full max-w-sm">
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-white mb-2">Добро пожаловать</h1>
            <p className="text-slate-500 text-sm">Введите данные для входа в систему</p>
          </div>

          <LoginForm onLogin={handleLogin} />
        </div>

        <p className="mt-12 text-xs text-slate-700 text-center">
          Нет аккаунта? Обратитесь к вашему HR-менеджеру.
        </p>
      </div>

      <link
        href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </div>
  );
}
